export const ERROR_PAGE_NAV_I18N = {
  startOrdering: 'start_ordering',
} as const;
